import { toast } from "react-toastify";
import fetcher from "../../lib/fetcher";
import useSWRMutation from "swr/mutation";
import { IUserOtpRequest } from "../interfaces";

const useChangeNumberPhoneRequest = () => {
  async function changeNumberPhoneRequest(
    url: string,
    { arg }: { arg: { phone: string } }
  ) {
    try {
      const data = await fetcher.swr<IUserOtpRequest>(url, {
        params: { phone: arg.phone },
      });

      return data.data;
    } catch (error: any) {
      toast.error(`Что-то не так. Проверьте номер. Причина: ${error}`);
      throw new Error(error);
    }
  }

  const { data, error, isMutating, trigger } = useSWRMutation(
    "/auth/request-phone-change",
    changeNumberPhoneRequest
  );

  return { data: data, error, isMutating, trigger };
};
export default useChangeNumberPhoneRequest;
